export default {
  user_module_legalCompliance_home: {
    path: 'legal-compliance/:moduleBridgeHex/plant-select',
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_legalCompliance_evaluation: {
    path: 'legal-compliance/:moduleBridgeHex/evaluation/:plantHex/:page/:filtersHex/',
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_legalCompliance_calendar: {
    path: 'legal-compliance/:moduleBridgeHex/calendar/:plantHex',
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_legalCompliance_configuration: {
    path: 'legal-compliance/:moduleBridgeHex/configuration/',
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_legalCompliance_pendingEmails: {
    path: 'legal-compliance/:moduleBridgeHex/pending-emails/',
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_legalCompliance_plantObligationForm_edit: {
    path: 'legal-compliance/:moduleBridgeHex/edit-form/:plantHex/',
    parameters: {
      clientID: undefined,
      moduleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_legalCompliance_plantObligationForm_manage: {
    path: 'legal-compliance/:moduleBridgeHex/manage-form/:plantHex/',
    parameters: {
      clientID: undefined,
      moduleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_legalCompliance_plantInformation: {
    path: 'legal-compliance/:moduleBridgeHex/plant-information/:plantHex/',
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_legalCompliance_plantConfiguration: {
    path: 'legal-compliance/:moduleBridgeHex/plant-configuration/:plantHex/',
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_legalCompliance_internalObligation: {
    path: 'legal-compliance/:moduleBridgeHex/internal-obligation/:plantHex/',
    parameters: {
      clientID: undefined,
      moduleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_legalCompliance_evidences: {
    path: 'legal-compliance/:moduleBridgeHex/evidences/:plantHex/',
    parameters: {
      clientID: undefined,
      moduleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_legalCompliance_autofilter: {
    path: 'legal-compliance/auto-filter/:clientID/:moduleBridgeHex/:plantHex/:obligationHex/',
    parameters: {
      clientID: undefined,
      moduleBridgeHex: undefined,
      plantHex: undefined,
      obligationHex: undefined,
    },
  },
  user_module_legalCompliance_userQuery_list: {
    path: 'legal-compliance/:moduleBridgeHex/user-query/:plantHex/list/',
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_legalCompliance_userQuery_messages: {
    path: 'legal-compliance/:moduleBridgeHex/user-query/:plantHex/messages/:userQueryThreadHEX/',
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: undefined,
      userQueryThreadHEX: undefined,
    },
  },
};
